import { createContext } from "react";

export type TStatus = 'error' | 'success' | 'warning' | 'info'

export type ErrorSuccessContext = {
  setErrorSuccess: (
    {
      mensagem,
      status
    }:
      {
        mensagem: string,
        status: TStatus
      }
  ) => void,
  setMensagemSuccess: (mensagem: string) => void,
  setMensagemError: (mensagem: string) => void,
  setMensagemInfo: (mensagem: string) => void,
}


/*@ts-ignore*/
export const ErrorSuccess = createContext<ErrorSuccessContext>(
  /*@ts-ignore*/
  () => { });
